import { render, staticRenderFns } from "./headerTemplate.vue?vue&type=template&id=0bb5533c&"
import script from "./headerTemplate.vue.js?vue&type=script&lang=js&"
export * from "./headerTemplate.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports